export default __webpack_public_path__ + "static/media/CookingImage4.19fcc9fe.png";